<template>
  <div
    v-html="
      feather.icons[name].toSvg({
        color,
        class: 'Icon',
        width: variableSize,
        height: variableSize,
        'stroke-width': 3,
        ...options,
      })
    "
  />
</template>

<script>
import { mapGetters } from 'vuex'
import feather from "feather-icons";
import _ from "lodash";

/**
 * For documentation about the feather api go to:
 * https://github.com/feathericons/feather#feathericonsnametosvgattrs
 */

export default {
  props: {
    name: String,
    options: Object,
    size: {
      type: [String, Number],
      default : '1rem'
    },
    color: {
      type: [String],
      default: "#000",
    },
  },
  data() {
    return {
      feather,
    };
  },
  computed: {
    variableSize() {
      let s = this.size;
      return _.isString(s) ? s : s + "px";
    },
    ...mapGetters("Theme", [
         "orderTypeIconSize"
    ]),
  }
};
</script>

<style>
.Icon {
  /* stroke-width: 2px; */
}
</style>
